import classNames from 'classnames';

import ITypography from './types';
import useStyles from './styles';

const Typography = ({
  element = 'span',
  look = element,
  color,
  children,
  className,
}: ITypography) => {
  const styles = useStyles();

  const Tag = element;

  return (
    <Tag className={classNames(styles.root, `look-${look}`, className)} style={{ color }}>
      {children}
    </Tag>
  );
};

export default Typography;
